import { StaticPagesModule } from './../static-pages/static-pages.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { LoaderButtonModule } from '@flabs/shared/loader-button/loader-button.module';
import { RequiredMarkModule } from '@flabs/shared/required-mark/required-mark.module';
import { TranslateModule } from '@ngx-translate/core';
import { LoginComponent } from './login.component';

const routes: Routes = [{ path: '', component: LoginComponent }];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forChild(),
    LoaderButtonModule,
    RequiredMarkModule,
    StaticPagesModule
  ],
  declarations: [LoginComponent],
  exports: [LoginComponent],
})
export class LoginModule { }
